var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIndicatorWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "52px",
    viewBox: "0 0 58 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-indicator_warning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M53.6122595,43.6439079 C54.720982,45.5846401 53.3198012,48 51.0848961,48 L2.91366906,48 C0.680218932,48 -0.720961834,45.5846401 0.387760641,43.6439079 L24.4726466,1.46756044 C25.5900992,-0.489186812 28.4084659,-0.489186812 29.5259185,1.46756044 L53.6122595,43.6439079 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-indicator_warning"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warning-Icons",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    d: "M54.4806306,43.1479929 L54.4805542,43.1478592 C55.9701142,45.7552177 54.0876123,49 51.0848961,49 L2.91366906,49 C-0.0879408468,49 -1.96992104,45.7549149 -0.480623345,43.1480155 L23.6042719,0.97165192 C25.1055576,-1.65721731 28.8930076,-1.65721731 30.3942896,0.971645466 L54.4806306,43.1479929 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Color/Orange---Focus-Orange",
    mask: "url(#mask-2)",
    fill: "#E2B236"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.000000, -6.000000)",
    id: "G---Orange---Focus-Orange"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 60,
    height: 59
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndicatorWarning);
export default __webpack_public_path__ + "static/media/icon-indicator_warning.1d1b07fe54d967ce42c535a4959622bf.svg";
export { ForwardRef as ReactComponent };